export const removeButtonStyle = {
  padding: "6px 8px !important",
  borderRadius: "4px",
  backgroundColor: "#F2F3FB",
  textTransform: "none",
  fontWeight: 500,
  fontSize: 13,
  color: "#B7484A",
};

export const acceptButtonStyle = {
  ...removeButtonStyle,
  color: "#248B70",
};

export const styles = {
  contactIconsContainer: {
    ml: "-8px",
  },

  actionButtonsContainer: {
    display: "flex",
    gap: "15px",
    alignItems: "center",
  },

  pendingActionsContainer: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "15px",
  },

  moderatorBadgeOverlay: {
    position: "absolute",
    top: "0",
    right: "0",
    transform: "translate(25%, -25%)",
    borderRadius: "50%",
    width: "18px",
    height: "18px",
  },

  nameColumnWrapper: {
    display: "flex",
    alignItems: "center",
  },

  nameTextWrapper: {
    ml: "16px",
    maxWidth: "228px",
  },

  nameTypography: {
    fontSize: "15px",
    color: "rgba(62, 63, 76, 0.9)",
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "max-content",
  },

  mobileSummaryName: {
    color: "rgba(62, 63, 76, 0.9)",
    fontSize: "15px",
    fontWeight: 500,
  },

  sortHeader: {
    cursor: "pointer",
    userSelect: "none",
    display: "flex",
    alignItems: "center",
  },

  mobileAccordionContainer: {
    overflowY: "auto",
    height: "100%",
    paddingRight: "8px",
    paddingBottom: "16px",
  },

  tooltipStyles: {
    paddingY: "5px",
  },
};
